import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibSpinner } from '@chewy/kib-interstitials-react'
import { KibContainer } from '@chewy/kib-layout-react'

import '@chewy/kib-interstitials-styles/dist/styles/kib-spinner.css'
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './PaymentControls.module.scss'

export type PaymentControlsAlign = 'left' | 'center' | 'right'

interface PaymentControlsProps {
  align?: PaymentControlsAlign
  disabled?: boolean
  emphasis?: 'primary' | 'secondary'
  isLoading?: boolean
  primaryAction: () => void
  primaryText?: string
}

const getContainerClassName = (align?: PaymentControlsAlign): string => {
  if (align === 'right') return styles.containerRight
  if (align === 'center') return styles.containerCenter
  return styles.container
}

export const PaymentControls = ({
  align,
  disabled,
  emphasis,
  isLoading = false,
  primaryAction,
  primaryText,
}: PaymentControlsProps) => (
  <KibContainer className={getContainerClassName(align)}>
    <KibButtonNew
      disabled={disabled}
      emphasis={emphasis}
      icon={isLoading && <KibSpinner />}
      loading={isLoading}
      size="large"
      theme="action"
      onClick={primaryAction}
    >
      {primaryText}
    </KibButtonNew>
  </KibContainer>
)
